var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('polygon',{attrs:{"points":"19.24 13.52 4.09 13.52 4.78 10.5 19.93 10.48 19.24 13.52"}}),_c('polygon',{attrs:{"points":"13.41 19.16 10.25 19.98 10.31 4.81 13.41 4 13.41 19.16"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }